import React from "react";
import {
  useBodies,
  useCameras,
  useActuators,
  useEqualities,
  useJoints,
  useSites,
  useTendons,
  useWorldBodies,
} from "../../stores/sceneStore";

function bodyRecordHasCollisionGeoms(bodies) {
  return Object.values(bodies).some(
    (body) =>
      Array.isArray(body?.geoms) && body.geoms.some((geom) => geom && geom.visualOnly !== true)
  );
}

function bodyRecordHasInertials(bodies) {
  return Object.values(bodies).some((body) => !!body?.inertia);
}

function jointRecordHasVisibleMarkers(joints) {
  return Object.values(joints).some((joint) => joint?.kind !== "free");
}

function useSceneToolbarPresence() {
  const hasObjects = useWorldBodies((worldBodies) => worldBodies.length > 0);
  const hasJoints = useJoints(jointRecordHasVisibleMarkers);
  const hasSites = useSites((sites) => Object.keys(sites).length > 0);
  const hasTendons = useTendons((tendons) => Object.keys(tendons).length > 0);
  const hasActuators = useActuators((actuators) => Object.keys(actuators).length > 0);
  const hasEqualities = useEqualities((equalities) => Object.keys(equalities).length > 0);
  const hasCameras = useCameras((cameras) => Object.keys(cameras).length > 0);
  const hasCollisions = useBodies(bodyRecordHasCollisionGeoms);
  const hasInertials = useBodies(bodyRecordHasInertials);

  return React.useMemo(
    () => ({
      body: true,
      object: hasObjects,
      joint: hasJoints,
      visual: true,
      collision: hasCollisions,
      site: hasSites,
      inertial: hasInertials,
      camera: hasCameras,
      constraint: hasEqualities,
      tendon: hasTendons,
      actuator: hasActuators,
    }),
    [
      hasActuators,
      hasObjects,
      hasJoints,
      hasSites,
      hasTendons,
      hasEqualities,
      hasCameras,
      hasCollisions,
      hasInertials,
    ]
  );
}

export { useSceneToolbarPresence };
